import { render, staticRenderFns } from "./LinkMember.vue?vue&type=template&id=3fd04ab2&scoped=true"
import script from "./LinkMember.vue?vue&type=script&lang=js"
export * from "./LinkMember.vue?vue&type=script&lang=js"
import style0 from "./LinkMember.vue?vue&type=style&index=0&id=3fd04ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd04ab2",
  null
  
)

export default component.exports